import React from 'react';
import { Link } from 'react-router';
import {
  Card,
  Button,
} from 'semantic-ui-react';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';

// TODO: Update semantic-react-ui and use the centered property on the Card.Group
const FLEX_CENTERED_STYLE = {
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
};
const buttonStyle = {
  margin: '0 auto',
  display: 'block',
};

const LimitsExceededModal = ({ description, assetType }) => {
  const text =
   description
   || `Sorry, you have hit the limits of your current plan. Please upgrade your plan to add another ${assetType}.`;
  return (
    <Card.Group style={FLEX_CENTERED_STYLE}>
      <Card>
        <Card.Content header="Limits Exceeded" />
        <Card.Content textAlign="center">
          <img src="/images/limits.svg" style={{ height: '15em' }} alt="limits exceeded" />
        </Card.Content>
        <Card.Content description={text} />
        <Card.Content>
          <div>
            <Link to="/team/manage">
              <Button
                inverted
                color="pink"
                floated={null}
                style={buttonStyle}
                fluid
              >
              Upgrade now
              </Button>
            </Link>
          </div>
        </Card.Content>
      </Card>
    </Card.Group>
  );
};

export default LimitsExceededModal;



/** WEBPACK FOOTER **
 ** ./src/components/limits-exceeded-modal/index.js
 **/